import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import DtoPoint from '../../dto/DtoPoint'
import DtoKeyFigures from '../../../sites/dto/DtoKeyFigures'
import { filter, maxBy, minBy, sumBy } from 'lodash'
import DtoSiteType from '../../../referential/dto/DtoSiteType'
import SiteTypes from '../../../utils/mapUtils/SiteTypes'
import i18n from 'simple-react-i18n'
import { getPlurialWithNumber } from '../../../utils/StringUtils'
import { getDate } from '../../../utils/DateUtil'
import IndicatorPanel from '../../../dashboard/components/indicator/IndicatorPanel'
import { LEFT_POSITION, RIGHT_POSITION } from '../../../utils/PositionConstants'

class PointKeyFiguresPanel extends Component {
	constructor(props) {
		super(props)
	}

	createKeyFigureObject = (title, value, position = LEFT_POSITION) => {
		return {
			title: title,
			titlePosition: position,
			number: value
		}
	}

	getKeyFigures = () => {
		return filter(this.props.pointKeyFigures, (o) => {
			return o.typeId == this.props.siteType.id
		})
	}

	getPiezometerKeyfigures = () => {
		const keyFigures = this.getKeyFigures()
		if (keyFigures) {
			const keyFiguresToShow = []
			keyFigures.forEach((o) => {
				keyFiguresToShow.push(this.createKeyFigureObject(i18n.measure + getPlurialWithNumber(o.nbMeasure), o.nbMeasure, RIGHT_POSITION))
				keyFiguresToShow.push(this.createKeyFigureObject(i18n.of, getDate(o.beginDate)))
				keyFiguresToShow.push(this.createKeyFigureObject(i18n.to, getDate(o.endDate)))
			})
			return keyFiguresToShow
		}
		return []
	}

	getQualitometerKeyfigures = () => {
		const keyFigures = this.getKeyFigures()
		if (keyFigures && keyFigures.length) {
			const keyFiguresToShow = []
			if (this.props.siteType.parameter == SiteTypes.QUALITOMETER_SURFACE.type) {
				const analysisSum = sumBy(keyFigures, 'nbAnalysis')
				keyFiguresToShow.push(this.createKeyFigureObject(i18n.analysis + getPlurialWithNumber(analysisSum), analysisSum, RIGHT_POSITION))
				const firstDate = minBy(keyFigures, 'beginDate')
				if (firstDate) {
					keyFiguresToShow.push(this.createKeyFigureObject(i18n.of, getDate(firstDate.beginDate)))
				}
				const lastDate = maxBy(keyFigures, 'endDate')
				if (lastDate) {
					keyFiguresToShow.push(this.createKeyFigureObject(i18n.to, getDate(lastDate.endDate)))
				}
				keyFiguresToShow.push(this.createKeyFigureObject(i18n.point.samplingPoint + getPlurialWithNumber(keyFigures.length), keyFigures.length))
			} else {
				keyFigures.forEach((o) => {
					keyFiguresToShow.push(this.createKeyFigureObject(i18n.analysis + getPlurialWithNumber(o.nbAnalysis), o.nbAnalysis, RIGHT_POSITION))
					keyFiguresToShow.push(this.createKeyFigureObject(i18n.of, getDate(o.beginDate)))
					keyFiguresToShow.push(this.createKeyFigureObject(i18n.to, getDate(o.endDate)))
				})
			}
			return keyFiguresToShow
		}
		return []
	}

	getData = () => {
		switch (this.props.siteType.parameter) {
			case SiteTypes.QUALITOMETER.type:
			case SiteTypes.QUALITOMETER_SURFACE.type:
				return this.getQualitometerKeyfigures()
			case SiteTypes.PIEZOMETER.type:
			case SiteTypes.PIEZOMETER_REFERENCE.type:
				return this.getPiezometerKeyfigures()
			default:
				return []
		}
	}


	render() {
		const data = this.getData()
		return (
			<div className='row no-margin'>
				<div className='col s12 no-padding'>
					<IndicatorPanel datas={ data }/>
				</div>
			</div>
		)
	}
}

PointKeyFiguresPanel.propTypes = {
	siteType: PropTypes.objectOf(DtoSiteType),
	point: PropTypes.objectOf(DtoPoint),
	pointKeyFigures: PropTypes.arrayOf(PropTypes.objectOf(DtoKeyFigures)),
	siteTypes: PropTypes.arrayOf(PropTypes.objectOf(DtoSiteType))
}

const mapStateToProps = store => {
	return {
		point: store.PointReducer.point,
		pointKeyFigures: store.PointReducer.pointKeyFigures,
		siteTypes: store.ReferentialReducer.siteTypes
	}
}

export default connect(mapStateToProps)(PointKeyFiguresPanel)



// WEBPACK FOOTER //
// ./src/point/components/keyFigures/PointKeyFiguresPanel.js